// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a4d4713a","455":"15eeee09","977":"9a0dbc91"}[chunkId] + ".chunk.js";
};